import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

export const ChatWithBoActivityHeaderSection = () => {
  return (
    <Box
      className="border-b border-sapphire-100"
      bgcolor="var(--team-app-bo-header-bg)"
      display="flex"
      columnGap="1rem"
      rowGap={0}
      boxShadow="0px 4px 12px 0px var(--team-app-bo-header-shadow)"
      sx={{
        padding: {
          xs: "1rem 1.75rem",
          sm: "1rem 1rem 1rem 3rem",
        },
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        alignItems: {
          xs: "flex-start",
          sm: "center",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap="1rem"
        flexShrink={0}
      >
        <FontAwesomeIcon
          icon={faInfoCircle}
          className="text-sapphire-50 text-lg"
        />
        <Typography variant="cardTitle" className="text-sapphire-50">
          Private to you
        </Typography>
      </Box>
      <Typography
        variant="activitySubtitle"
        className="text-white sm:text-teamApp-text-muted-dark"
        sx={{
          fontSize: {
            xs: "12px",
            sm: "1rem",
          },
          lineHeight: {
            xs: "1rem",
            sm: "1.625rem",
          },
        }}
      >
        Only you can see this chat. Your manager won&rsquo;t see your messages
        or a summary.
      </Typography>
    </Box>
  );
};
